"use strict";

var cov_2g38sx3u9v = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\MilestoneObject.js";
  var hash = "bce77ce3e50292c232e3d82ed18e3ea9f6573995";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\MilestoneObject.js",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 66,
          column: 3
        }
      },
      "1": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 32,
          column: 8
        }
      },
      "2": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 31,
          column: 10
        }
      },
      "3": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 12
        }
      },
      "4": {
        start: {
          line: 35,
          column: 27
        },
        end: {
          line: 42,
          column: 7
        }
      },
      "5": {
        start: {
          line: 43,
          column: 27
        },
        end: {
          line: 43,
          column: 46
        }
      },
      "6": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 40
        }
      },
      "7": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 61,
          column: 7
        }
      },
      "8": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 52,
          column: 10
        }
      },
      "9": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 60,
          column: 10
        }
      },
      "10": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 12
        }
      },
      "11": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 28
        }
      },
      "12": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 12
        }
      },
      "13": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 72,
          column: 4
        }
      },
      "14": {
        start: {
          line: 75,
          column: 0
        },
        end: {
          line: 90,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "MilestoneObject",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 24
          }
        },
        loc: {
          start: {
            line: 22,
            column: 3
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 31
          },
          end: {
            line: 26,
            column: 32
          }
        },
        loc: {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 31,
            column: 10
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 33,
            column: 12
          }
        }, {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 62,
            column: 12
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 65,
            column: 12
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 27
          },
          end: {
            line: 43,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 27
          },
          end: {
            line: 43,
            column: 40
          }
        }, {
          start: {
            line: 43,
            column: 44
          },
          end: {
            line: 43,
            column: 46
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }, {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 45,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 45,
            column: 31
          }
        }, {
          start: {
            line: 45,
            column: 35
          },
          end: {
            line: 45,
            column: 67
          }
        }],
        line: 45
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "bce77ce3e50292c232e3d82ed18e3ea9f6573995"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require(".");

function MilestoneObject(_ref) {
  var originalWords = _ref.originalWords,
      _ref$verseObject = _ref.verseObject,
      tag = _ref$verseObject.tag,
      children = _ref$verseObject.children,
      strong = _ref$verseObject.strong,
      lemma = _ref$verseObject.lemma,
      morph = _ref$verseObject.morph,
      occurrence = _ref$verseObject.occurrence,
      occurrences = _ref$verseObject.occurrences,
      content = _ref$verseObject.content,
      disableWordPopover = _ref.disableWordPopover;
  cov_2g38sx3u9v.f[0]++;
  var component;
  cov_2g38sx3u9v.s[0]++;

  switch (tag) {
    case 'k':
      cov_2g38sx3u9v.b[0][0]++;
      cov_2g38sx3u9v.s[1]++;
      component = children.map(function (child, index) {
        cov_2g38sx3u9v.f[1]++;
        cov_2g38sx3u9v.s[2]++;
        return _react.default.createElement(_.VerseObject, {
          key: index,
          verseObject: child,
          disableWordPopover: disableWordPopover
        });
      });
      cov_2g38sx3u9v.s[3]++;
      break;

    case 'zaln':
      cov_2g38sx3u9v.b[0][1]++;
      var originalWord = (cov_2g38sx3u9v.s[4]++, {
        strong: strong,
        lemma: lemma,
        morph: morph,
        occurrence: occurrence,
        occurrences: occurrences,
        content: content
      });

      var _originalWords = (cov_2g38sx3u9v.s[5]++, (cov_2g38sx3u9v.b[1][0]++, originalWords) || (cov_2g38sx3u9v.b[1][1]++, []));

      cov_2g38sx3u9v.s[6]++;

      _originalWords.push(originalWord);

      cov_2g38sx3u9v.s[7]++;

      if ((cov_2g38sx3u9v.b[3][0]++, children.length === 1) && (cov_2g38sx3u9v.b[3][1]++, children[0].type === 'milestone')) {
        cov_2g38sx3u9v.b[2][0]++;
        cov_2g38sx3u9v.s[8]++;
        component = _react.default.createElement(_.VerseObject, {
          verseObject: children[0],
          originalWords: _originalWords,
          disableWordPopover: disableWordPopover
        });
      } else {
        cov_2g38sx3u9v.b[2][1]++;
        cov_2g38sx3u9v.s[9]++;
        component = _react.default.createElement(_.AlignedWordsObject, {
          originalWords: _originalWords,
          children: children,
          disableWordPopover: disableWordPopover
        });
      }

      cov_2g38sx3u9v.s[10]++;
      break;

    default:
      cov_2g38sx3u9v.b[0][2]++;
      cov_2g38sx3u9v.s[11]++;
      component = _react.default.createElement("span", null);
      cov_2g38sx3u9v.s[12]++;
      break;
  }

  cov_2g38sx3u9v.s[13]++;
  return _react.default.createElement(_react.default.Fragment, null, component);
}

;
cov_2g38sx3u9v.s[14]++;
MilestoneObject.propTypes = {
  verseObject: _propTypes.default.shape({
    tag: _propTypes.default.string,
    type: _propTypes.default.string,
    content: _propTypes.default.string,
    children: _propTypes.default.arrayOf(_propTypes.default.object),
    strong: _propTypes.default.string,
    lemma: _propTypes.default.string,
    morph: _propTypes.default.string,
    occurrence: _propTypes.default.string,
    occurrences: _propTypes.default.string
  }).isRequired,
  originalWords: _propTypes.default.array,

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool
};
var _default = MilestoneObject;
exports.default = _default;